module.exports = __webpack_public_path__ + "static/media/starshipsBanner.9d7fc8e4.jpg";